export default __webpack_public_path__ + "static/media/buyerInfo.f9bc6154.svg";